import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {I18n} from 'react-redux-i18n';
import ViPropTypes from '../../propTypes';
import DashboardFrameData from '../DashboardFrameData';
import {SYSTEM_MEASURE} from '../../util/SystemMeasure';

export default class GaugeDashboard extends React.Component {

  static propTypes = {
    mediaLoaded: PropTypes.bool,
    currentFrame: PropTypes.instanceOf(DashboardFrameData),
    customerSettings: ViPropTypes.CustomerSettings,
    userSettings: ViPropTypes.UserSettings
  }

  static defaultProps = {
    mediaLoaded: false,
    currentSecond: 0,
    currentFrame: new DashboardFrameData(),
    customerSettings: {
      gpsSpeed: false
    },
    userSettings: {
      settings: {
        systemMeasure: 'imperial'
      }
    }
  }

  render() {
    const {
      mediaLoaded,
      currentFrame,
      customerSettings,
      userSettings
    } = this.props;

    const shouldUseMetric = userSettings.settings.systemMeasure === SYSTEM_MEASURE.METRIC;

    return (
      <div className={classnames({
        dashboard: true,
        'dashboard-closed dashboard-after': !mediaLoaded
      })}>
        <div className="dashboard__gauges">
          <div className="col1">
            <div
              className={classnames({
                'mph-postedspeed': true,
                hidegps: customerSettings.gpsSpeed === false
              })}
            >
              <div
                className={classnames({
                  mphgauge: true,
                  disabled: !currentFrame.engineSpeed.present
                })}
              >
                {currentFrame.engineSpeed.value} {`${shouldUseMetric ? 'KM/H' : 'MPH'}`}
              </div>
              <div className={classnames({
                postedspeedgauge: true,
                disabled: !currentFrame.postedSpeed.present,
                'postedspeedgauge-danger': currentFrame.postedSpeed.excessive,
                'postedspeedgauge-warning': currentFrame.postedSpeed.over
              })}>
                <span className="postedspeedgauge__title">
                  {I18n.t('page.playerPage.mobileDashboard.postedSpeed')}
                </span>
                <span className="postedspeedgauge__speed">
                  {currentFrame.postedSpeed.value}
                </span>
              </div>
            </div>
            <div
              className={classnames({
                'rpm-gps': true,
                hidegps: customerSettings.gpsSpeed === false
              })}
            >
              <div
                className={
                  classnames({
                    rpm: true,
                    disabled: !currentFrame.rpm.present
                  })
                }
              >
                {currentFrame.rpm.value} RPM
              </div>
              <div
                className={classnames({
                  gps: true,
                  disabled: !currentFrame.gpsSpeed.present
                })}
              >
                {currentFrame.gpsSpeed.value} GPS
              </div>
            </div>
          </div>
          <div className="col2">
            <div
              className={classnames({
                headwayinfo: true,
                disabled: !currentFrame.forwardSpeed.present
              })}
            >
              <div className="headwayinfo__text">
                <span className="headwayinfo__icon fvs">
                  {I18n.t('page.playerPage.mobileDashboard.forwardVehicleSpeed')}
                </span>
                <span>
                  {currentFrame.forwardSpeed.value} {`${shouldUseMetric ? 'KM/H' : 'MPH'}`}
                </span>
              </div>
              <div className="headwayinfo__container">
                <div
                  className="headwayinfo__progress"
                  style={{
                    width: `${currentFrame.forwardSpeed.percent}%`}
                  }
                />
                <div className="headwayinfo__bg" />
              </div>
            </div>
            <div
              className={classnames({
                headwayinfo: true,
                disabled: !currentFrame.forwardDistance.present
              })}
            >
              <div className="headwayinfo__text">
                <span className="headwayinfo__icon fd">
                  {I18n.t('page.playerPage.mobileDashboard.followingDistance')}
                </span>
                <span>
                  {`${currentFrame.forwardDistance.value} ${currentFrame.forwardDistance.unit}`}
                </span>
              </div>
              <div className="headwayinfo__container">
                <div
                  className="headwayinfo__progress"
                  style={{
                    width: `${currentFrame.forwardDistance.percent}%`
                  }}
                />
                <div className="headwayinfo__bg" />
              </div>
            </div>
            <div
              className={classnames({
                headwayinfo: true,
                disabled: !currentFrame.acceleration.present
              })}
            >
              <div className="headwayinfo__text">
                <span className="headwayinfo__icon acc">
                  {I18n.t('page.playerPage.mobileDashboard.accelerator')}
                </span>
                <span>
                  {currentFrame.acceleration.value} %
                </span>
              </div>
              <div className="headwayinfo__container">
                <div
                  className="headwayinfo__progress"
                  style={{
                    width: `${currentFrame.acceleration.value}%`
                  }}
                />
                <div className="headwayinfo__bg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
